<template>
  <div>
    <div class="d-flex justify-end sticky to-header">
      <v-btn
        v-if="hasRight('KEY_WRITE')"
        v-bind="$config.buttonAttrs.floating"
        :to="{ name: 'NewKeyCabinet' }"
        title="Új kulcsszekrény"
      >
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </div>

    <h1 class="py-6">Kulcsszekrény lista</h1>

    <v-expansion-panels class="mb-4" :mandatory="!!Object.values(search).find((e) => e !== '')">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span>
            <v-icon left>mdi-filter</v-icon>
            Szűrés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2">
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card :loading="loading">
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
        :item-class="itemClass"
      >
        <template #[`item.actions`]="{ item }">
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="secondary"
            class="rounded-sm mr-1"
            :to="{ name: 'KeyCabinetEditor', params: { id: item.id } }"
            title="Szerkesztés"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('KEY_WRITE')"
            text
            fab
            small
            dark
            color="secondary"
            class="rounded-sm ma-1"
            @click="deleteKeyCabinet(item)"
            title="Törlés"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'KeyCabinetList',
      fetchItems: this.fetchKeyCabinets,
      dataTable: {
        options: {
          sortBy: ['key_cabinet_name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'key_cabinet_name' },
          { text: 'Épület', value: 'building_name' },
          { text: 'Szint', value: 'building_level_name' },
          { text: 'Megjegyzés', value: 'remark', sortable: false },
          { text: 'Kulcsok száma', value: 'keys_count', sortable: false },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        name: '',
      },
      groups: [],
      searchTimeout: null,
    };
  },

  methods: {
    parseSearchQueries() {
      return {
        name: this.$route.query.name,
        building_name: this.$route.query.building_name,
      };
    },

    async deleteKeyCabinet(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> kulcsszekrény törlésére készül! Folytatja?`,
        title: 'Figyelem',
      });

      if (confirm) {
        try {
          this.loading = true;
          const response = await this.$http.post(`key-cabinets/delete/${item.id}`);
          this.fetchKeyCabinets();
          if (response.status === 'OK') {
            this.$dialog.notify.info('A kulcsszekrény törölve');
          }
        } catch (e) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },

    async fetchKeyCabinets() {
      this.loading = true;
      try {
        const response = await this.$http.post('key-cabinets/list', this.postData);
        this.dataTable.items = response.key_cabinets;
        this.dataTable.itemsLength = response.key_cabinets_count;
        this.dataTable.options.page = Number(this.$route.query.page) || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        name: this.search.name || '',
        building_name: this.search.building_name || '',
      };
    },
  },
};
</script>
